

































import {
    Component,
    Prop,
    Vue,
Watch,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';
const appModule = namespace('app');

import * as _ from 'lodash';

@Component({
    components: {},
})
export default class AdminSidebar extends Vue {

    @appModule.State('isCollapse')
    private isCollapse!: boolean;

    private rootSubmenuKeys: any[] = [];

    private currentRouteName: any[] = [];
    private openMenus: any[] = [];

    constructor() {
        super();
    }

    get menuData() {
        const router: any = this.$router;
        return router.options.routes;
    }

    private parentMenuName(name: any) {
        const menuList = this.menuData;
        const childList = _.map(menuList, (item: any) => {
            return _.map(item.children, (citem: any) => {
                citem.parentName = item.name;
                return citem;
            });
        });
        const list = _.flatten(childList);
        const menu = _.find(list, (o: any) => o.name === name);
        return menu.parentName;
    }

    private mounted() {
        this.currentRouteName = [this.$route.name];
        const roots = _.filter(this.menuData, (item: any) => item.children != null );
        this.rootSubmenuKeys = _.map(roots, 'name');
        this.initOpenMenus();
    }

    private handleOpenChange(openKeys: any) {
        const latestOpenKey = openKeys.find((key: any) => this.openMenus.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.openMenus = openKeys;
        } else {
            this.openMenus = latestOpenKey ? [latestOpenKey] : [];
        }
    }

    private initOpenMenus() {
        const name = this.$route.name;
        const openKey = this.parentMenuName(name);
        this.handleOpenChange([openKey]);
    }

    private displayMenuTitle(menu: any) {
        if (menu.meta.i18n) {
            return this.$t(menu.meta.i18n);
        }
        return menu.meta.title;
    }

    @Watch('$route')
    private watchRouteName(newVal: any, oldVal: any) {
        this.currentRouteName = [newVal.name];
    }

    @Watch('isCollapse')
    private watchisCollapse(newVal: any, oldVal: any) {
        if (newVal === true) {
            this.openMenus = [];
        } else {
            this.initOpenMenus();
        }
    }
}
